
import { Vue, Component, Prop } from "vue-property-decorator";
// Entities
import { Company, Profile } from "@/entities/index";
// Services
import { getPiecesCde } from "@/services";

@Component
export default class Chart5 extends Vue {
  @Prop() readonly warehouseCode!: string;
  client = this.company.codeLogistic || this.profile.company.codeLogistic;
  integrateStepZero = this.company.integrateStepZero;

  piecesCde: unknown[] = [];

  get optionsPiecesCde(): unknown {
    return {
      labels: this.$t("dataDashboard.charts.chart4.labels"),
      colors: ["#154077", "#aabb00", "#00BAA2", "#f46969"],
    };
  }

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  async loadPiecesCde(): Promise<void> {
    const { currentPiecesStatus } = await getPiecesCde({
      client: this.client,
      warehouse: this.warehouseCode,
    });
    this.piecesCde = currentPiecesStatus;
  }
}
